(function () {
  // v2 landing-page chart (research/audits/2026-09-04-baltic-volatility-
  // regime-v2-follow-up-plan.md sections 8-10, Candidate D: volatility
  // impulse). Deliberately a SEPARATE element id/file from
  // baltic-volatility-regime-chart.js (v1) - that file and the section that
  // loads it are untouched and remain the one customers see until this v2
  // component is explicitly approved and wired into the live section (plan:
  // "Only update Shopify after v2 is published to a staging endpoint and
  // approved").
  var el = document.getElementById('bb-baltic-vol-impulse-chart');
  if (!el) return;

  var ENDPOINT_URL = el.getAttribute('data-endpoint-url');
  var SCHEMA_VERSION = 'baltic_volatility_regime_v2';
  var EXPECTED_CALCULATION_VERSION = 'baltic_volatility_impulse_v1';
  // Widened 2026-09-05 (research/audits/2026-09-05-baltic-volatility-impulse-
  // universe-widening.md in hedgefund-api) from the original 4-ticker
  // universe to 9. INF1T deliberately excluded for now - see that doc.
  var EXPECTED_UNIVERSE = ['LHV1T', 'TAL1T', 'MRK1T', 'TKM1T', 'CPA1T', 'TSM1T', 'ARC1T', 'TVE1T', 'HAE1T'];
  var MAX_MONTHS = 36; // defensive client-side cap, same as v1 - never widens what the server sent.

  var POSITIVE_LEGEND = el.getAttribute('data-positive-legend');
  var NEGATIVE_LEGEND = el.getAttribute('data-negative-legend');
  var ZEROLINE_LABEL = el.getAttribute('data-zeroline-label');
  var THROUGH_LABEL = el.getAttribute('data-through-label');
  var UPDATED_LABEL = el.getAttribute('data-updated-label');
  var UNAVAILABLE_TEXT = el.getAttribute('data-unavailable-text');
  var STALE_LABEL = el.getAttribute('data-stale-label');
  var TOOLTIP_IMPULSE_LABEL = el.getAttribute('data-tooltip-impulse-label');
  var TOOLTIP_ABOVE_BASELINE_LABEL = el.getAttribute('data-tooltip-above-baseline-label');
  var TOOLTIP_BELOW_BASELINE_LABEL = el.getAttribute('data-tooltip-below-baseline-label');
  var TOOLTIP_AT_BASELINE_LABEL = el.getAttribute('data-tooltip-at-baseline-label');
  var TOOLTIP_BREADTH_LABEL = el.getAttribute('data-tooltip-breadth-label');
  var TOOLTIP_COVERAGE_LABEL = el.getAttribute('data-tooltip-coverage-label');
  var YAXIS_TITLE = el.getAttribute('data-yaxis-title');
  var MONTHS = (el.getAttribute('data-months') || '').split(',');

  var metaEl = document.getElementById('bb-baltic-vol-impulse-meta');
  var staleEl = document.getElementById('bb-baltic-vol-impulse-stale');
  var proofStripEl = document.getElementById('bb-hero-proof-strip');

  function showUnavailable(reason) {
    console.warn('BullBreak baltic-volatility-impulse chart unavailable:', reason);
    el.classList.add('bb-chart-unavailable');
    if (UNAVAILABLE_TEXT) {
      el.textContent = '';
      var msg = document.createElement('div');
      msg.className = 'bb-chart-unavailable-text';
      msg.textContent = UNAVAILABLE_TEXT;
      el.appendChild(msg);
    }
  }

  function formatDate(dateStr) {
    var parts = dateStr.split('-');
    var monthIndex = parseInt(parts[1], 10) - 1;
    var monthName = (MONTHS.length === 12 && MONTHS[monthIndex]) || dateStr.slice(5, 7);
    return parseInt(parts[2], 10) + ' ' + monthName + ' ' + parts[0];
  }

  // Re-validates the v2 contract client-side, same discipline as v1's
  // validatePayload - a public unauthenticated fetch is never trusted just
  // because it parsed as JSON. A v1 payload must fail here (wrong
  // schema/calculation_version), and vice versa.
  function validatePayload(payload) {
    if (!payload || payload.schema_version !== SCHEMA_VERSION) return 'schema_version mismatch';
    if (payload.calculation_version !== EXPECTED_CALCULATION_VERSION) return 'unexpected calculation_version';

    if (!Array.isArray(payload.universe) || payload.universe.length !== EXPECTED_UNIVERSE.length) {
      return 'universe does not match the fixed ' + EXPECTED_UNIVERSE.length + '-equity universe';
    }
    var universeSorted = payload.universe.slice().sort();
    var expectedSorted = EXPECTED_UNIVERSE.slice().sort();
    for (var u = 0; u < expectedSorted.length; u++) {
      if (universeSorted[u] !== expectedSorted[u]) return 'universe does not match the fixed ' + EXPECTED_UNIVERSE.length + '-equity universe';
    }

    var generatedMs = Date.parse(payload.generated_at);
    if (!payload.generated_at || isNaN(generatedMs)) return 'invalid generated_at timestamp';

    if (!Array.isArray(payload.points) || payload.points.length === 0) return 'no points';
    if (payload.point_count !== payload.points.length) return 'point_count does not match points.length';

    var todayIso = new Date().toISOString().slice(0, 10);
    var prevDate = null;
    for (var i = 0; i < payload.points.length; i++) {
      var p = payload.points[i];
      if (!p || typeof p.date !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(p.date)) return 'malformed point date';
      if (prevDate !== null && p.date <= prevDate) return 'points not strictly increasing by date';
      prevDate = p.date;
      if (p.date > todayIso) return 'a point has a future date';

      if (typeof p.aggregate_impulse !== 'number' || !isFinite(p.aggregate_impulse)) {
        return 'aggregate_impulse not a finite number';
      }
      // Deliberately NOT range-checked to +/-50 or similar - the plan's own
      // instruction is not to clamp this value to fit a chart axis.
      if (p.coverage_count !== EXPECTED_UNIVERSE.length) return 'coverage_count is not ' + EXPECTED_UNIVERSE.length;
      if (typeof p.breadth_accelerating !== 'number' || p.breadth_accelerating < 0 || p.breadth_accelerating > EXPECTED_UNIVERSE.length) {
        return 'breadth_accelerating out of [0, ' + EXPECTED_UNIVERSE.length + ']';
      }
    }

    if (payload.data_through !== payload.points[payload.points.length - 1].date) {
      return 'data_through does not match the final point date';
    }
    if (payload.data_through > todayIso) return 'data_through is in the future';

    return null;
  }

  function impulsePhrase(impulse) {
    if (impulse === 0) return ZEROLINE_LABEL || '21-session volatility equals 63-session volatility';
    // Derived directly and only from the payload's own impulse value
    // (impulse = 100*ln(HV21/HV63)), never an independent recalculation:
    // the equivalent HV21-vs-HV63 percentage difference is exp(impulse/100)-1.
    var pct = (Math.exp(impulse / 100) - 1) * 100;
    var magnitude = Math.abs(pct).toFixed(0);
    return magnitude + '% ' + (impulse > 0
      ? (TOOLTIP_ABOVE_BASELINE_LABEL || 'above 3-month baseline')
      : (TOOLTIP_BELOW_BASELINE_LABEL || 'below 3-month baseline'));
  }

  // Presentation-only split of the one canonical `aggregate_impulse` value
  // into an above-baseline and a below-baseline line - never two
  // independently calculated series. Each line is null on the other side of
  // zero, and where consecutive sessions change sign both get one extra
  // point at y=0, placed where the straight line between those two sessions
  // crosses the baseline. Without it (the old max(v,0)/min(v,0) split) the
  // orange line reached zero on the later session while the blue one left
  // zero on the earlier session, so the two never met at a crossing and both
  // ran flat along the baseline. The extra points lie on the segment already
  // drawn between two real values; they are not payload data and carry no
  // tooltip (hover comes from the separate trace of real points only).
  function splitAtBaseline(points) {
    var x = [], above = [], below = [];
    for (var i = 0; i < points.length; i++) {
      var v = points[i].aggregate_impulse;
      var prev = i > 0 ? points[i - 1].aggregate_impulse : 0;
      if (prev * v < 0) {
        var t0 = Date.parse(points[i - 1].date + 'T00:00:00Z');
        var t1 = Date.parse(points[i].date + 'T00:00:00Z');
        var crossing = new Date(t0 + (t1 - t0) * (prev / (prev - v)));
        x.push(crossing.toISOString().slice(0, 19).replace('T', ' '));
        above.push(0);
        below.push(0);
      }
      x.push(points[i].date);
      above.push(v >= 0 ? v : null);
      below.push(v <= 0 ? v : null);
    }
    return { x: x, above: above, below: below };
  }

  function renderChart(payload) {
    var points = payload.points;
    var cutoff = new Date(points[points.length - 1].date + 'T00:00:00Z');
    cutoff.setUTCMonth(cutoff.getUTCMonth() - MAX_MONTHS);
    points = points.filter(function (p) { return new Date(p.date + 'T00:00:00Z') >= cutoff; });

    var dates = points.map(function (p) { return p.date; });
    var split = splitAtBaseline(points);
    var tooltipData = points.map(function (p) {
      return [
        (TOOLTIP_IMPULSE_LABEL || 'Volatility impulse') + ': ' + p.aggregate_impulse.toFixed(1),
        impulsePhrase(p.aggregate_impulse),
        p.breadth_accelerating + '/' + EXPECTED_UNIVERSE.length + ' ' + (TOOLTIP_BREADTH_LABEL || 'equities accelerating'),
        EXPECTED_UNIVERSE.length + '/' + EXPECTED_UNIVERSE.length + ' ' + (TOOLTIP_COVERAGE_LABEL || 'equities covered'),
      ];
    });

    // Signed line with a restrained area fill (plan section 10, form 2) -
    // chosen over signed bars because the series moves smoothly (~4% daily
    // sign-flip rate in the displayed window; see
    // research/experiments/baltic-volatility-regime-v2/model_comparison.md),
    // so hundreds of adjacent bars would read as decorative texture rather
    // than clarify the regime, exactly what the plan warns against. No
    // smoothing is applied - this is the exact daily payload value.
    // Muted burnt-orange/slate-blue, not the original saturated orange/blue
    // (2026-09-12 light-theme audit: "Keep orange for above-baseline
    // volatility and blue for below-baseline volatility... The problem is
    // the overall chart treatment... not simply that orange is absent from
    // the logo" - same distinction, toned down to sit on a white card
    // instead of a near-black one). Width 1.25 -> 1.5 (audit's "1.5-1.75px
    // at ordinary desktop size" range) and fill opacity 0.28 -> 0.10 (audit
    // table: "start at 10%; acceptable preview range 8-12%") so the fills
    // support the lines rather than dominate them.
    var data = [
      {
        name: POSITIVE_LEGEND || 'Short-term volatility above 3-month baseline',
        x: split.x, y: split.above, type: 'scatter', mode: 'lines',
        line: { color: '#B66A32', width: 1.5, shape: 'linear' },
        fill: 'tozeroy', fillcolor: 'rgba(182, 106, 50, 0.10)',
        connectgaps: false,
        hoverinfo: 'skip',
      },
      {
        name: NEGATIVE_LEGEND || 'Short-term volatility below 3-month baseline',
        x: split.x, y: split.below, type: 'scatter', mode: 'lines',
        line: { color: '#5368A6', width: 1.5, shape: 'linear' },
        fill: 'tozeroy', fillcolor: 'rgba(83, 104, 166, 0.10)',
        connectgaps: false,
        hoverinfo: 'skip',
      },
      // Invisible: the exact payload values, one per session, and the only
      // trace that answers hover - so a tooltip can never land on one of
      // the baseline-crossing points added by splitAtBaseline.
      {
        x: dates, y: points.map(function (p) { return p.aggregate_impulse; }),
        type: 'scatter', mode: 'lines', line: { width: 0 },
        hovertemplate: '%{x|%Y-%m-%d}<br>%{customdata[0]}<br>%{customdata[1]}<br>%{customdata[2]}<br>%{customdata[3]}<extra></extra>',
        customdata: tooltipData,
      },
    ];

    // Light theme (2026-09-12 light-theme audit, C03): paper/plot white,
    // gridlines a quiet #E9ECF1, tick/legend/axis-title text a readable
    // slate (#526071), baseline shape/annotation a distinct neutral gray
    // (#8993A3) rather than a near-invisible 10%-white line that only read
    // on the dark card this replaces. One coordinated change, not a partial
    // recolor - a white card with the old dark-theme grid/tick colors would
    // have been unreadable.
    var layout = {
      shapes: [{
        line: { color: '#8993A3', dash: 'dot', width: 1.25 },
        type: 'line', x0: 0, x1: 1, xref: 'x domain', y0: 0, y1: 0, yref: 'y',
      }],
      // margin.t 16, not 20 (2026-09-12 light-theme audit) - the header
      // (title/legend/Studio link) is now a normal-flow row above the
      // plot (snippets/baltic-volatility-impulse-chart.liquid's
      // .bb-chart-header), not an overlay stealing space from it, so this
      // is only top-edge breathing room for the plotted line again.
      font: { family: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif", color: '#526071', size: 12 },
      margin: { l: 52, r: 24, t: 16, b: 40 },
      xaxis: { tickfont: { color: '#526071', size: 12 }, gridcolor: '#E9ECF1', linecolor: '#DDE1E8' },
      yaxis: {
        tickfont: { color: '#526071', size: 12 }, gridcolor: '#E9ECF1', linecolor: '#DDE1E8',
        zeroline: false, autorange: true,
        title: { text: YAXIS_TITLE || 'Volatility impulse (HV21 vs HV63)', font: { size: 12, color: '#526071' } },
      },
      // showlegend:false, no title key - both are supplied as normal-flow
      // HTML in .bb-chart-header (snippets/baltic-volatility-impulse-
      // chart.liquid) instead, so Plotly must not also draw its own
      // copies. POSITIVE_LEGEND/NEGATIVE_LEGEND stay wired to each trace's
      // own `name` below (still useful metadata even with the legend
      // hidden) - only the dedicated layout.title/layout.legend objects
      // are gone.
      showlegend: false,
      hoverlabel: {
        font: { size: 11, family: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif", color: '#1f2430' },
        bgcolor: '#ffffff', bordercolor: '#DDE1E8',
      },
      paper_bgcolor: '#ffffff', plot_bgcolor: '#ffffff', autosize: true,
    };

    layout.annotations = [{
      x: 1, xref: 'paper', xanchor: 'right', y: 0, yref: 'y', yanchor: 'bottom',
      text: ZEROLINE_LABEL || 'Baseline', showarrow: false,
      font: { size: 12, color: '#526071' }, yshift: 4,
    }];

    if (metaEl && THROUGH_LABEL) {
      var throughText = THROUGH_LABEL + ' ' + formatDate(payload.data_through);
      var updatedText = '';
      if (UPDATED_LABEL && payload.generated_at) {
        var genDate = payload.generated_at.slice(0, 10);
        var genTime = payload.generated_at.slice(11, 16);
        updatedText = ' · ' + UPDATED_LABEL + ' ' + formatDate(genDate) + ' ' + genTime + ' UTC';
      }
      metaEl.textContent = throughText + updatedText;
    }

    if (staleEl && STALE_LABEL && payload.freshness && payload.freshness.status === 'stale') {
      staleEl.textContent = STALE_LABEL + ' ' + formatDate(payload.data_through);
      staleEl.style.display = '';
    }

    // Mobile proof strip (P1-A) - only revealed once real validated data is
    // available, never shown with placeholder/guessed content. Originally
    // count and date only ("do not invent a bullish/bearish summary"); the
    // card was reported live as promising a "reading" but never showing
    // one, so {value} now reuses impulsePhrase() - the exact same non-
    // directional phrasing ("X% above/below 3-month baseline") already
    // shown in the desktop chart's own tooltips, not a new invented
    // summary - for the latest point in `points` (already date-sorted,
    // so the last element is the most recent).
    if (proofStripEl) {
      var latestPoint = points[points.length - 1];
      var headingTemplate = proofStripEl.getAttribute('data-heading');
      var bodyTemplate = proofStripEl.getAttribute('data-body-template');
      var headingEl = proofStripEl.querySelector('.bb-hero__proof-strip-heading');
      var bodyEl = proofStripEl.querySelector('.bb-hero__proof-strip-body');
      if (headingEl && bodyEl && bodyTemplate) {
        headingEl.textContent = headingTemplate || '';
        bodyEl.textContent = bodyTemplate
          .replace('{value}', impulsePhrase(latestPoint.aggregate_impulse))
          .replace('{count}', String(payload.universe.length))
          .replace('{date}', formatDate(payload.data_through));
        proofStripEl.hidden = false;
      }
    }

    var plotConfig = { displayModeBar: false, responsive: false };
    // Zoom hint wording + close-button name (assets/bb-plotly-hint.js; look in base.css).
    if (window.bbPlotlyHint) window.bbPlotlyHint.apply(Plotly, plotConfig, el.getAttribute('data-close-label'), {
      zoomPointer: el.getAttribute('data-zoom-hint-pointer'),
      zoomTouch: el.getAttribute('data-zoom-hint-touch'),
      legendPointer: el.getAttribute('data-legend-hint-pointer'),
      legendTouch: el.getAttribute('data-legend-hint-touch')
    });

    Plotly.newPlot('bb-baltic-vol-impulse-chart', data, layout, plotConfig).then(function (gd) {
      // Track the size actually applied so the ResizeObserver below only
      // redraws on a *real* change (2026-09-11 follow-up: "chart loads
      // slightly smaller, then extends" reported live). ResizeObserver's
      // spec guarantees an initial callback right after observe() starts,
      // whether or not the size has genuinely changed since the explicit
      // resize() two lines below already handled - without this guard,
      // that guaranteed initial fire called Plotly.Plots.resize() a
      // second time regardless, and any sub-pixel difference between the
      // two back-to-back getBoundingClientRect() reads (a known source of
      // jitter with CSS grid + aspect-ratio sizing) redrew the chart a
      // visible moment after it had already faded in.
      var lastWidth = gd.clientWidth;
      var lastHeight = gd.clientHeight;

      Promise.resolve(Plotly.Plots.resize(gd)).then(function () {
        lastWidth = gd.clientWidth;
        lastHeight = gd.clientHeight;
        requestAnimationFrame(function () {
          gd.style.opacity = '1';
        });
      });

      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () {
          if (gd.clientWidth === lastWidth && gd.clientHeight === lastHeight) return;
          lastWidth = gd.clientWidth;
          lastHeight = gd.clientHeight;
          Plotly.Plots.resize(gd);
        });
        ro.observe(gd.parentElement);
      }
    });
  }

  function loadChartData() {
    if (!ENDPOINT_URL) {
      showUnavailable('no endpoint URL configured');
      return;
    }
    fetch(ENDPOINT_URL, { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (payload) {
        var validationError = validatePayload(payload);
        if (validationError) {
          throw new Error('payload failed client-side validation: ' + validationError);
        }
        renderChart(payload);
      })
      .catch(function (err) {
        showUnavailable(err);
      });
  }

  if (window.Plotly) {
    loadChartData();
  } else {
    var s = document.createElement('script');
    s.src = 'https://cdn.plot.ly/plotly-2.32.0.min.js';
    s.onload = loadChartData;
    s.onerror = function () { showUnavailable('Plotly failed to load'); };
    document.head.appendChild(s);
  }
})();
